import { useMediaQuery } from '@mantine/hooks';

type TDeviceType = {
  isDesktop: boolean;
  isLaptop: boolean;
  isTablet: boolean;
  isMobile: boolean;
};

function useDeviceType(): TDeviceType {
  // Breakpoints aligned with theme: sm=40em (640px), lg=64em (1024px), xl=75em (1200px)
  const isDesktop = useMediaQuery('(min-width: 88em)') ?? false;
  const isLaptop = useMediaQuery('(min-width: 64em) and (max-width: 74.9375em)') ?? false;
  const isTablet = useMediaQuery('(min-width: 40em) and (max-width: 63.9375em)') ?? false;
  const isMobile = useMediaQuery('(max-width: 39.9375em)') ?? false;

  return {
    isDesktop,
    isLaptop,
    isTablet,
    isMobile,
  };
}

export default useDeviceType;
